import React from "react";
import Nav from "react-bootstrap/lib/Nav";
import { connect } from "react-redux";
import { func, string, shape, bool, number, node } from "prop-types";

import { actions as sessionActions, selectors as sessionSelectors } from "reducers/session";
// import { selectors as i18nSelectors } from "reducers/i18n";
import { selectors as transactionsSelectors } from "reducers/transactions";
import { CORPORATE_GROUP_ENVIRONMENT_TYPE, NEW_ENROLLMENT_ENVIRONMENT_TYPE } from "constants.js";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";

import MenuFormItem from "pages/_components/menu/MenuFormItem";
import MenuItem from "pages/_components/menu/MenuItem";
import MenuSection from "pages/_components/menu/MenuSection";

class Menu extends React.Component {
    static propTypes = {
        dispatch: func.isRequired,
        isMobile: bool,
        isAdministrator: bool,
        activeEnvironment: shape({
            permissions: shape({
                accounts: bool,
                creditcards: bool,
                payCreditCard: bool,
                payLoan: bool,
                payThirdPartiesCreditCard: bool,
                payThirdPartiesLoan: bool,
                requestTransactionCancellation: bool,
                transferForeign: bool,
                transferInternal: bool,
                transferLocal: bool,
                transferThirdParties: bool,
                holdings: bool,
                scheduledDebin: bool,
            }),
            forms: shape({}),
            administrationScheme: string,
            type: string,
        }).isRequired,
        // lang: string.isRequired,
        pendingTransactionsQuantity: number,
    };

    static defaultProps = {
        isMobile: false,
        isAdministrator: false,
        pendingTransactionsQuantity: 0,
    };

    logOut = () => {
        const { dispatch } = this.props;
        dispatch(sessionActions.logout());
    };

    buildAdministrationMenu = () => {
        const { isMobile, isAdministrator, activeEnvironment } = this.props;

        let admMenu = null;
        if (!isMobile && isAdministrator) {
            if (activeEnvironment?.administrationScheme !== "simple") {
                admMenu = (
                    <MenuSection
                        titleKey="administration.menu.name"
                        key="menu.administration"
                        image="images/figma/icon/administracion.svg">
                        <MenuItem
                            titleKey="administration.menu.users"
                            key="menu.administration.users"
                            linkTo="/administration/users"
                        />
                        {activeEnvironment?.administrationScheme !== "medium" && (
                            <MenuItem
                                titleKey="administration.menu.groups"
                                key="menu.administration.groups"
                                linkTo="/administration/groups"
                            />
                        )}
                        <MenuItem
                            titleKey="administration.menu.signatureScheme"
                            key="menu.administration.signatureScheme"
                            linkTo={`/administration/${activeEnvironment?.administrationScheme}/signaturesSchemes`}
                        />
                        {activeEnvironment?.permissions.otherProducts && (
                            <MenuItem
                                titleKey="menu.financing.otherProduct"
                                key="menu.financing.requestDiscount"
                                linkTo="/loans/otrosProductos"
                            />
                        )}
                        {/* {activeEnvironment?.permissions?.physicalCheckbook && (
                            <MenuItem
                                titleKey="menu.checks.requestCheckbook"
                                key="menu.checks.requestCheckbook"
                                linkTo="/checks/requestCheckbookForm"
                            />
                        )} */}
                    </MenuSection>
                );
            } else {
                admMenu = (
                    <MenuItem
                        titleKey="administration.menu.name"
                        key="menu.administration"
                        linkTo="/administration/users"
                        image="images/figma/icon/administration.svg"
                    />
                );
            }
        }

        return admMenu;
    };

    // eslint-disable-next-line class-methods-use-this
    constructMenuFormItems() {
        const menuItems = [];
        return menuItems;
    }

    // eslint-disable-next-line class-methods-use-this
    constructMenuSection(activeEnvironment, menuName, titleKey, ImageSection, linkTo) {
        let menuSection = null;
        const menuItems = [];

        if (
            (menuName !== "deposits" && menuName !== "financing" && menuName !== "investments") ||
            activeEnvironment?.permissions[menuName]
        ) {
            menuItems.push(<MenuItem titleKey={titleKey} key={titleKey} linkTo={linkTo} />);
        }

        let sectionForms = activeEnvironment?.forms[menuName];
        // Exception in form of credtCard Menu
        if (menuName === "creditcards" && !activeEnvironment?.permissions[menuName] && sectionForms) {
            sectionForms = sectionForms.filter(
                ({ idForm }) => !["additionalCreditCardRequest", "lostOrStolenCreditCard"].includes(idForm),
            );
        }

        if (menuName === "investments" && activeEnvironment?.permissions.listDeposits) {
            menuItems.push(
                <MenuItem titleKey="menu.deposits.myDeposits" key="menu.deposits.myDeposits" linkTo="/deposits" />,
            );
        }

        if (menuName === "investments" && activeEnvironment?.permissions.listCedips) {
            menuItems.push(
                <MenuItem titleKey="menu.management.cedip" key="menu.management.cedip" linkTo="/depositsCedip" />,
            );
        }

        if (menuName === "investments" && activeEnvironment?.permissions.holdings) {
            menuItems.push(
                <MenuItem
                    titleKey="menu.investmentFunds.holdings"
                    key="menu.investmentFunds.holdings"
                    linkTo="/holdings"
                    notificationNew="global.new.notification"
                />,
            );
        }

        if (menuName === "accounts" && activeEnvironment?.permissions.cashOut) {
            menuItems.push(<MenuItem titleKey="menu.cashout" key="menu.cashout" linkTo="/cashOut" />);
        }

        if (menuName === "financing" && activeEnvironment?.permissions.listEcheqsForDiscount) {
            menuItems.push(
                <MenuItem
                    titleKey="menu.financing.requestDiscount"
                    key="menu.financing.requestDiscount"
                    linkTo="/discounts"
                />,
            );
        }

        if (
            menuName === "financing" &&
            activeEnvironment?.permissions.listLoans &&
            configUtils.getBoolean("unsecured.loans.enable")
        ) {
            menuItems.push(
                <MenuItem
                    titleKey="menu.financing.loansList"
                    key="menu.financing.loansList"
                    title="Préstamos"
                    linkTo="/loans"
                />,
            );
        }

        if (menuItems.length > 0) {
            menuSection = (
                <MenuSection
                    id={`menu.${menuName}`}
                    titleKey={`menu.${menuName}`}
                    key={`menu.${menuName}`}
                    image={ImageSection}>
                    {menuItems}
                </MenuSection>
            );
        }
        return menuSection;
    }

    render() {
        const { activeEnvironment, isMobile, pendingTransactionsQuantity } = this.props;

        // Desktop
        const desktopMenuSection = (
            <MenuItem
                titleKey="menu.desktop"
                key="menu.desktop"
                linkTo="/desktop"
                image="images/figma/icon/inicio.svg"
            />
        );

        // Acounts
        const accountMenuSection = this.constructMenuSection(
            activeEnvironment,
            "accounts",
            "menu.accounts.myAccounts",
            "images/figma/icon/cuentas.svg",
            "/accounts",
        );

        // Transfers
        let transferMenuSection = null;
        let transferMenuItems = [];
        if (activeEnvironment?.permissions.accounts) {
            if (activeEnvironment?.permissions.listDestinations) {
                transferMenuItems.push(
                    <MenuFormItem
                        link="/contactDestination"
                        key="contactDestination"
                        name={i18n.get("transfer.frequentDestination.title")}
                    />,
                );
            }
            if (activeEnvironment?.permissions.generateTransfer) {
                // TODO We must check if the feature `transfers.internal.send` is also available?
                transferMenuItems.push(
                    <MenuFormItem link="/transfers" key="transferInternal" name={i18n.get("transfer.title")} />,
                );
            }

            if (activeEnvironment?.permissions.generateMep) {
                transferMenuItems.push(
                    <MenuFormItem link="/mep" key="mepTransfers" name={i18n.get("transfer.mep.title")} />,
                );
            }

            transferMenuItems = transferMenuItems.concat(this.constructMenuFormItems());
            if (transferMenuItems.length > 0) {
                transferMenuSection = (
                    <MenuSection
                        id="menu.transfers"
                        titleKey="menu.transfers"
                        key="menu.transfers"
                        image="images/figma/icon/transferencias.svg">
                        {transferMenuItems}
                    </MenuSection>
                );
            }
        }

        // Debin
        let debinMenuSection = null;
        const debinMenuItems = [];
        if (activeEnvironment?.permissions.debin) {
            debinMenuItems.push(
                <MenuItem titleKey="menu.innmediate.debin" key="menu.innmediate.debin" linkTo="/debinPayments" />,
            );
        }

        if (activeEnvironment?.permissions.scheduledDebin) {
            debinMenuItems.push(
                <MenuItem
                    titleKey="menu.scheduled.debin"
                    key="menu.payments.scheduledDebin"
                    linkTo="/scheduledDebin"
                />,
            );
        }

        if (debinMenuItems.length > 0) {
            debinMenuSection = (
                <MenuSection titleKey="debin.main.title" key="debin.main" image="images/figma/icon/debin.svg">
                    {debinMenuItems}
                </MenuSection>
            );
        }

        let echeqMenuSection = null;
        if (activeEnvironment?.permissions.listEcheqs) {
            echeqMenuSection = (
                <MenuItem
                    titleKey="menu.checks.echecks"
                    key="menu.checks.echecks"
                    linkTo="/echecks"
                    image="images/figma/icon/cheques.svg"
                />
            );
        }

        // Billing
        let creditBillMenuSection = null;
        if (activeEnvironment?.permissions.listFcemInvoice) {
            creditBillMenuSection = (
                <MenuItem
                    titleKey="creditBill.menu.title"
                    key="menu.creditBill"
                    linkTo="/creditBills"
                    image="images/figma/icon/FCE.svg"
                />
            );
        }

        // Payments
        let paymentMenuSection = null;
        let paymentMenuItems = [];

        if (activeEnvironment?.permissions.accounts) {
            if (activeEnvironment?.permissions.transferThirdParties) {
                paymentMenuItems.push(
                    <MenuItem
                        titleKey="menu.payments.lotPayments"
                        key="menu.payments.lotPayments"
                        linkTo="/lotPayments"
                    />,
                );
            }

            if (configUtils.getBoolean("services.payment.link.enable", true)) {
                if (activeEnvironment?.permissions.servicesPayment) {
                    paymentMenuItems.push(
                        <MenuItem
                            titleKey="menu.payments.service"
                            key="menu.payments.service"
                            linkTo="/servicesPayment"
                        />,
                    );
                }
            } else if (activeEnvironment?.permissions.listBookedPayments) {
                paymentMenuItems.push(
                    <MenuItem titleKey="menu.payments.service" key="menu.payments.service" linkTo="/servicePayments" />,
                );
            }

            if (activeEnvironment?.permissions.vepPayment && configUtils.getBoolean("vep.payment.enable")) {
                paymentMenuItems.push(
                    <MenuItem
                        titleKey="menu.payments.vepPayment"
                        key="menu.payments.vepPayment"
                        linkTo="/vepPayments"
                    />,
                );
            }

            if (configUtils.getBoolean("payroll.payment.enabled", false))
                if (activeEnvironment?.permissions.payrollPayment) {
                     paymentMenuItems.push(
                        <MenuItem
                            titleKey="menu.payments.massPayrollPayment"
                            key="menu.payments.massPayrollPayment"
                            linkTo="/massPayroll"
                        />,
                    );
                }

            paymentMenuItems = paymentMenuItems.concat(this.constructMenuFormItems());
            if (paymentMenuItems.length > 0) {
                paymentMenuSection = (
                    <MenuSection titleKey="menu.payments" key="menu.payments" image="images/figma/icon/pagos.svg">
                        {paymentMenuItems}
                    </MenuSection>
                );
            }
        }

        // Recollections
        let recollectionMenuSection = null;
        let recollectionMenuItems = [];
        if (activeEnvironment?.permissions.paymentRecollection) {
            recollectionMenuItems.push(
                <MenuItem
                    titleKey="menu.payments.collections"
                    key="menu.payments.collections"
                    linkTo="/recollections"
                />,
            );
        }

        // Direct Debit
        if (activeEnvironment?.permissions.directDebit) {
            recollectionMenuItems.push(
                <MenuItem titleKey="menu.payments.directdebit" key="menu.payments.directdebit" linkTo="/directDebit" />,
            );
        }

        recollectionMenuItems = recollectionMenuItems.concat(this.constructMenuFormItems());
        if (recollectionMenuItems.length > 0) {
            recollectionMenuSection = (
                <MenuSection titleKey="menu.collections" key="menu.collections" image="images/figma/icon/cobros.svg">
                    {recollectionMenuItems}
                </MenuSection>
            );
        }

        // Position
        let positionMenuItem = null;
        if (activeEnvironment?.permissions.position) {
            positionMenuItem = (
                <MenuItem
                    titleKey="menu.position"
                    key="menu.position"
                    linkTo="/position"
                    image="images/posicionConsolidada.svg"
                />
            );
        }

        // Transactions
        const transactionsMenuSection = (
            <MenuItem
                titleKey="menu.transactions"
                key="menu.transactions"
                linkTo="/transactions/list"
                image="images/figma/icon/historial.svg"
            />
        );

        // Pending dispatch
        const pendingDispatch = (
            <MenuItem
                titleKey="pendingDispatch.list.title"
                key="pendingDispatch.list.title"
                linkTo="/pendingTransaction/list"
                image="images/figma/icon/transacciones-pendientes.svg"
                notificationCount={pendingTransactionsQuantity}
                notificationCountTextID="menu.pendingDispatch.badge"
            />
        );

        // Settings
        const settingsMenuItem = (
            <MenuItem
                titleKey="menu.settings"
                key="menu.settings"
                linkTo="/settings"
                image="images/figma/icon/administracion.svg"
            />
        );

        // Financing
        const financingMenuSection = this.constructMenuSection(
            activeEnvironment,
            "financing",
            "menu.request.unsecuredLoan",
            "images/figma/icon/financiaciones.svg",
            "/requestUnsecuredLoan",
        );

        // Investments
        let investmentsMenuSection = null;
        const investmentsMenuItems = [];

        if (activeEnvironment?.permissions.holdings) {
            investmentsMenuItems.push(
                <MenuItem
                    titleKey="menu.investmentFunds.holdings"
                    key="menu.investmentFunds.holdings"
                    linkTo="/holdings"
                    notificationNew="global.new.notification"
                />,
            );
        }

        if (activeEnvironment?.permissions.listDeposits) {
            investmentsMenuItems.push(
                <MenuItem titleKey="menu.deposits.myDeposits" key="menu.deposits.myDeposits" linkTo="/deposits" />,
            );
        }

        if (activeEnvironment?.permissions.listCedips) {
            investmentsMenuItems.push(
                <MenuItem titleKey="menu.management.cedip" key="menu.management.cedip" linkTo="/depositsCedip" />,
            );
        }

        if (investmentsMenuItems.length > 0) {
            investmentsMenuSection = (
                <MenuSection
                    titleKey="menu.investments"
                    key="menu.investments"
                    image="images/figma/icon/inversiones.svg"
                    notificationNew>
                    {investmentsMenuItems}
                </MenuSection>
            );
        }

        // Comex
        let comexMenuSection = null;
        let comexMenuItems = [];

        if (activeEnvironment?.permissions.accounts && configUtils.getBoolean("comex.enable")) {
            if (activeEnvironment?.permissions.generateComex) {
                comexMenuItems.push(<MenuItem titleKey="transfers.comex.title" key="menu.comex" linkTo="/comex" />);
            }

            comexMenuItems = comexMenuItems.concat(this.constructMenuFormItems());
            if (comexMenuItems.length > 0) {
                comexMenuSection = (
                    <MenuSection
                        id="menu.comex"
                        titleKey="menu.comex"
                        key="menu.comex"
                        image="images/figma/icon/comex.svg">
                        {comexMenuItems}
                    </MenuSection>
                );
            }
        }

        // Administration
        const administrationMenuSection = this.buildAdministrationMenu();

        if (activeEnvironment?.type === NEW_ENROLLMENT_ENVIRONMENT_TYPE) {
            return (
                <Nav className="menu-list" role="menu">
                    <FirstLevelItem>{desktopMenuSection}</FirstLevelItem>
                </Nav>
            );
        }

        return (
            <Nav className="menu-list" role="menu">
                <FirstLevelItem>{desktopMenuSection}</FirstLevelItem>
                <FirstLevelItem>{accountMenuSection}</FirstLevelItem>
                <FirstLevelItem>{transferMenuSection}</FirstLevelItem>
                <FirstLevelItem>{debinMenuSection}</FirstLevelItem>
                <FirstLevelItem>{echeqMenuSection}</FirstLevelItem>
                <FirstLevelItem>{financingMenuSection}</FirstLevelItem>
                <FirstLevelItem>{investmentsMenuSection}</FirstLevelItem>
                <FirstLevelItem>{paymentMenuSection}</FirstLevelItem>
                <FirstLevelItem>{recollectionMenuSection}</FirstLevelItem>
                <FirstLevelItem>{comexMenuSection}</FirstLevelItem>
                <FirstLevelItem>{creditBillMenuSection}</FirstLevelItem>
                <FirstLevelItem>{positionMenuItem}</FirstLevelItem>
                <FirstLevelItem>{transactionsMenuSection}</FirstLevelItem>
                {activeEnvironment?.type !== CORPORATE_GROUP_ENVIRONMENT_TYPE && (
                    <FirstLevelItem>{pendingDispatch}</FirstLevelItem>
                )}
                <FirstLevelItem>{administrationMenuSection}</FirstLevelItem>
                {isMobile && <FirstLevelItem>{settingsMenuItem}</FirstLevelItem>}
            </Nav>
        );
    }
}
function FirstLevelItem({ children }) {
    return (
        <li role="menuitem" className="menu-list-item">
            {children}
        </li>
    );
}

FirstLevelItem.propTypes = {
    children: node.isRequired,
};

const mapStateToProps = (state) => ({
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    // lang: i18nSelectors.getLang(state),
    isAdministrator: sessionSelectors.isAdministrator(state),
    pendingTransactionsQuantity: transactionsSelectors.getPendingTransactionsQuantity(state),
});

export default connect(mapStateToProps)(Menu);
